import {
  InputText as OriginalInputText,
  InputTextProps,
} from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import WithController from '../with-controller';
import InputEnhancements, { FormInputEnhancements } from './input-enhancements';

const InputText = WithController<PropTypes, string>(
  ({
    className,
    field,
    fieldState,
    formState: _formState,
    addonRight,
    addonLeft,
    label,
    withErrorMessage,
    containerClassName,
    triggerDependencies,
    ...props
  }) => (
    <InputEnhancements
      addonRight={addonRight}
      addonLeft={addonLeft}
      label={label}
      withErrorMessage={withErrorMessage}
      containerClassName={containerClassName}
      field={field}
      fieldState={fieldState}
    >
      <OriginalInputText
        disabled={field.disabled}
        {...props}
        name={field.name}
        onBlur={field.onBlur}
        onChange={(event) => {
          field.onChange(event.target.value);
          triggerDependencies();
        }}
        ref={field.ref}
        value={field.value}
        id={field.name}
        className={classNames({ 'p-invalid': fieldState.error }, className)}
      />
    </InputEnhancements>
  ),
);

type OmittedProps = 'id' | 'name' | 'ref' | 'value' | 'onBlur' | 'onChange';

type PropTypes = Omit<InputTextProps, OmittedProps> & FormInputEnhancements;

export default InputText;
